import React from 'react'
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableFooter from '@mui/material/TableFooter'
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import DeliveryDiningIcon from '@mui/icons-material/DeliveryDining';
import './applicationTableEmploymentInfo.scss' 


const  ApplicationTableEmploymentInfo = ({ applicationData}) => {

                                   
 

  return (
            
    <div className='item'>

        {
            applicationData.isEmployed === "employed"

            ?

            <div className="details">

              
            <div className='detailItem'>
                <span className='itemKey'>Current Company:</span>
                <span className='itemValue'>{applicationData.currentCompany}</span>
            </div>
            <div className='detailItem'>
                <span className='itemKey'>Company Address:</span>
                <span className='itemValue'>{applicationData.companyAddress}</span>
            </div>
            <div className='detailItem'>
                <span className='itemKey'>Date Of Employment:</span>
                <span className='itemValue'>{applicationData.dateOfEmployment}</span>
            </div>

            <div className='detailItem'>
                <span className='itemKey'>Nature of Job:</span>
                <span className='itemValue'>{applicationData.natureOfJob}</span>
            </div>
            <div className='detailItem'>
                <span className='itemKey'>Work Position:</span>
                <span className='itemValue'>{applicationData.workPosition}</span>
            </div>
            <div className='detailItem'>
                <span className='itemKey'>Job Duties:</span>
                <span className='itemValue'>{applicationData.jobDuties}</span>
            </div>
            <div className='detailItem'>
                <span className='itemKey'>Previous Company:</span>
                <span className='itemValue'>{applicationData.previousCompany}</span>
            </div>
    
            <div className='detailItem'>
                <span className='itemKey'>Previous Company Address:</span>
                <span className='itemValue'>{applicationData.previousCompanyAddress}</span>
            </div>
            <div className='detailItem'>
                <span className='itemKey'>Previous Nature of Job:</span>
                <span className='itemValue'>{applicationData.previousCompanyNatureOfJob}</span>
            </div>

            <div className='detailItem'>
                <span className='itemKey'>Prvious Nature of Job:</span>
                <span className='itemValue'>{applicationData.dateOfPreviousEmployment}</span>
            </div>
            <div className='detailItem'>
                <span className='itemKey'>Previous Job Position:</span>
                <span className='itemValue'>{applicationData.previousJobPosition}</span>
            </div>
            <div className='detailItem'>
                <span className='itemKey'>Previous Job Duties:</span>
                <span className='itemValue'>{applicationData.previousJobDuties}</span>
            </div>
        
        </div>

            :
            


            <div className="details">

              
            <div className='detailItem'>
                <span className='itemKey'>Employment:</span>
                <span className='itemValue'>Not Employed</span>
            </div>
            
        </div>

        }

        
    </div>
   
  );
}

export default ApplicationTableEmploymentInfo